<template>
  <div class="app-page">
    <div class="app-page-header">
      <img src="../assets/login/back.png" @click="back"/>
      <span class="title">绑定结果</span>
      <img src="../assets/login/back.png" style="visibility: hidden"/>
    </div>
    <div class="app-page-content">
      <div class="app-card">
        <div class="box">
          <img src="../assets/login/fail.png"/>
          <div class="text">您已绑定失败</div>
        </div>
      </div>
    </div>
    <div class="app-page-footer">
      <div class="bottom" @click="clear">重置</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'fail',
    data(){
      return{

      }
    },
    methods:{
      back:function () {
        console.log("返回到绑定页面");
        this.$router.go(-1);
      },
    //重置
      clear:function () {
        console.log("重置页面");
        this.$router.go(-1)
      }
    },
    created(){

    }
  }
</script>

<style scoped lang="scss">
  .app-page-content{
    .app-card{
      height: 100vh;
      margin-top: -48px;
      display: flex;
      justify-content: center;
      align-items: center;
      .box{
        width: 90px;
        text-align: center;
        img{
          height: 100px;
          width: 90px;
        }
        .text{
          margin-top: 14.5px;
          color: #333333;
          font-size: 15px;
        }
      }
    }
  }
  .app-page-footer{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    .bottom{
      width: 100%;
      height: 45px;
      background-color: #1655bf;
      color: #ffffff;
      font-size: 17px;
      text-align: center;
      line-height: 45px;
    }
  }
</style>
